import Duck from 'extensible-duck';

var selectors = function selectors() {
  return {
    getClaim: new Duck.Selector(function () {
      return function (state) {
        var _state$data;
        return state === null || state === void 0 ? void 0 : (_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data.claim;
      };
    }),
    getOutboundClaim: new Duck.Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.outboundClaim;
      };
    }),
    getTokens: new Duck.Selector(function () {
      return function (state) {
        var _state$claim;
        return state === null || state === void 0 ? void 0 : (_state$claim = state.claim) === null || _state$claim === void 0 ? void 0 : _state$claim.data;
      };
    })
  };
};

export { selectors as default };
//# sourceMappingURL=selectors.js.map
